<template>
    <div class="toggle-container filters-container" :key="keyToReRender">
        <div class="panel style1 arrow-right">
            <h4 class="panel-title">
                <a data-toggle="collapse" href="#modify-search-panel" class="collapsed">{{ modifysearch[getCurrentLocale] }}</a>
            </h4>
            <div id="modify-search-panel" class="panel-collapse collapse">
                <div class="panel-content">
                    <div class="search-content">
                        <form @submit.prevent="onSubmit">
                            <div class="form-group">
                                <label>{{ departuredate[getCurrentLocale] }}:</label>
                                 <vue-pikaday
                                    v-model="date_from"
                                    name="date_from"
                                    :placeholder="pickdeparturedate[getCurrentLocale]"
                                    class="input-text full-width"
                                    :options="options[getCurrentLocale]"
                                    :value="getBookingUsersSearchData.depAfter | birthdate"
                                 />
                                <!--
                                <div class="datepicker-wrap sundair">
                                    <input type="text" name="date_from" class="input-text full-width" placeholder="dd.mm.yy" :value="getBookingUsersSearchData.depAfter | birthdate">
                                </div>
                                -->
                            </div>
                            <div class="form-group">
                                <label v-show="getBookingUsersSearchData.rTrip === true">{{ returndate[getCurrentLocale] }}:</label>
                                 <vue-pikaday
                                    v-show="getBookingUsersSearchData.rTrip === true"
                                    v-model="date_to"
                                    name="date_to"
                                    :placeholder="pickreturndate[getCurrentLocale]"
                                    class="input-text full-width"
                                    :options="options[getCurrentLocale]"
                                    :value="getBookingUsersSearchData.retAfter | birthdate"
                                 />
                                <!--
                                <div class="datepicker-wrap sundair" v-show="getBookingUsersSearchData.rTrip === true">
                                    <input type="text" name="date_to" class="input-text full-width" placeholder="dd.mm.yy" :value="getBookingUsersSearchData.retAfter | birthdate">
                                </div>
                                -->
                            </div>
                            <br />
                            <button class="btn-medium icon-check uppercase full-width">{{ searchagain[getCurrentLocale] }}</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import axios from 'axios';
    import moment from 'moment';
    import VueScrollTo from 'vue-scrollto';

    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                modifysearch: {
                    en: 'Modify Search',
                    de: 'Suche verändern',
                },
                departuredate: {
                    en: 'Pick a new Date Departure',
                    de: 'Neues Abflugdatum',
                },
                pickdeparturedate: {
                    en: 'Date Departure',
                    de: 'Neues Abflugdatum',
                },
                returndate: {
                    en: 'Pick a new Date Return',
                    de: 'Neues Rückflugdatum',
                },
                pickreturndate: {
                    en: 'Pick a new Date Return',
                    de: 'Neues Rückflugdatum',
                },
                searchagain: {
                    en: 'search again',
                    de: 'Suche verändern',
                },
                // currentLocale: 'de',
                // >>> --------------------------
                date_from: null,
                date_to: null,
                options: {
                    en: {
                        format: 'DD.MM.YYYY',
                        i18n: {
                            previousMonth : 'Previous Month',
                            nextMonth     : 'Next Month',
                            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
                            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
                            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
                        }
                    },
                    de: {
                        format: 'DD.MM.YYYY',
                        i18n: {
                            previousMonth : 'Vorheriger Monat',
                            nextMonth     : 'Nächster Monat',
                            months        : ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
                            weekdays      : ['Sonntag',' Montag',' Dienstag',' Mittwoch',' Donnerstag',' Freitag',' Samstag'],
                            weekdaysShort : ['SO','MO','DI','MI','DO','FR','SA']
                        }
                    },
                    // format: 'DD.MM.YYYY',
                    // minDate: moment().toDate(),
                    // maxDate: moment().add(7, 'days').toDate()
                },
                // >>> --------------------------
                keyToReRender: 0
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getBookingUsersSearchData',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::updated
        *
        * Desc:
        * Note:
        *
        */
        updated: function() {

            this.$nextTick(function () {
                if (this.keyToReRender !== 0) {
                    // console.log('rerendered!!! ');
                }
            });

        }, // eof updated()

        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function() {

            this.date_from = this.getBookingUsersSearchData.depAfter;
            this.date_to = this.getBookingUsersSearchData.retAfter;

            this.keyToReRender += 1;

        }, // eof mounted()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_FlagSharedShowFlightSearchResults',
                'actn_setBookingFlightSearchResults', // set: SearchResults
            ]),



            /******************************************************************* 'ServiceCalls - Common'
            * ServiceCalls:
            *******************************************************************/
            /*******************************************************************
            * Call::'/booking/listflights'
            *
            * Desc: Getting Flights ('listflights').
            * Note:
            *
            */
            call_listFlights: function(params) {

                var me = this,
                    hdrs = '',
                    options = {};


                me.$toc('>>> booking/flightsearch/ModifySearchBox.vue >>> call_listFlights');
                // this.onChange_FlightsSearchForm(); // reset
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };

                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.put('/booking/listflights/', params)
                    .then(function(response) { // 'OK'
                        me.$vp_um();
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.actn_setBookingFlightSearchResults(response.data.listFlightsRS.flts);
                                me.actn_FlagSharedShowFlightSearchResults(true); // Show 'Section'
                                setTimeout(function() {
                                    me.$scrollTo('#contentElement', 200, options);
                                }, 300);
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eof call_listFlights()



            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: ModifySearchBox Submit.
            * Note:
            *
            */
            onSubmit(submitEvent) {

                let me = this,
                    depAfter = '',
                    myDepPickerDate,
                    theActualTime,
                    isToday,
                    date_from,
                    date_to;


                me.$toc('>>> booking/flightsearch/ModifySearchBox.vue >>> onSubmit');
                me.actn_FlagSharedShowFlightSearchResults(false); // Show 'Section'

                // >>> 1. Check for Today&depAfter-Time ------------------------
                date_from = submitEvent.target.elements.date_from.value.split('.');
                myDepPickerDate = moment(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DD');

                theActualTime = moment().format('HH:mm:ss');
                isToday = moment(String(myDepPickerDate)).isSame(moment().format('YYYY-MM-DD'));
                if (isToday) {
                    depAfter = moment(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DDT') + theActualTime;
                }
                if (!isToday) {
                    depAfter = moment(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DDT00:00:ss+0000');
                }


                // >>> 2. Builds Object ----------------------------------------
                let requestParamObject = this.getBookingUsersSearchData;
                requestParamObject.depAfter = depAfter;

                // >>> 3. Oneway || Roundtrip ? --------------------------------
                if (this.getBookingUsersSearchData.rTrip  === true) {
                    date_to = submitEvent.target.elements.date_to.value.split('.');
                    requestParamObject.retAfter = moment(date_to[2] + '-' + date_to[1] + '-' + date_to[0]).format('YYYY-MM-DDTHH:mm:ss+0000');
                    requestParamObject.rTrip = true;
                }


                //this.actn_setBookingUsersSearchData(requestParamObject);  // remember in state
                this.call_listFlights(requestParamObject);

            }, // eof onSubmit()





            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * forceRerender()
            *
            * Desc: Simply change the Components :key to force rerendering.
            * Note:
            *
            */
            forceRerender() {

                var me = this;


                me.$toc('>>> booking/flightsearch/ModifySearchBox.vue >>> forceRerender');
                this.keyToReRender += 1;

            }, // eof forceRerender()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

